// 🚨 Auto-generated file. Do not edit manually.

export const heroImages = {
  paintCorrection: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741883598/mad-web-app/hero-images/paint-correction.jpg',
    publicId: 'mad-web-app/hero-images/paint-correction',
    alt: 'Paint Correction Hero Image',
  },
  homePage: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741880412/mad-web-app/hero-images/home-page.webp',
    publicId: 'mad-web-app/hero-images/home-page',
    alt: 'Home Page Hero Image',
  },
  giftCards: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741010439/mad-web-app/hero-images/gift-cards.png',
    publicId: 'mad-web-app/hero-images/gift-cards',
    alt: 'Gift Cards Hero Image',
  },
  blogs: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741009279/mad-web-app/hero-images/blogs.webp',
    publicId: 'mad-web-app/hero-images/blogs',
    alt: 'Blogs Hero Image',
  },
  booking: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740951149/mad-web-app/hero-images/booking.webp',
    publicId: 'mad-web-app/hero-images/booking',
    alt: 'Booking Hero Image',
  },
  windowTinting: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739935565/mad-web-app/hero-images/window-tinting.webp',
    publicId: 'mad-web-app/hero-images/window-tinting',
    alt: 'Window Tinting Hero Image',
  },
  contactUs: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739764510/mad-web-app/hero-images/contact-us.jpg',
    publicId: 'mad-web-app/hero-images/contact-us',
    alt: 'Contact Us Hero Image',
  },
  allServices: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739764111/mad-web-app/hero-images/all-services.jpg',
    publicId: 'mad-web-app/hero-images/all-services',
    alt: 'All Services Hero Image',
  },
  ceramicCoating: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739366697/mad-web-app/hero-images/ceramic-coating.jpg',
    publicId: 'mad-web-app/hero-images/ceramic-coating',
    alt: 'Ceramic Coating Hero Image',
  },
};
